import React from "react";
import Functionality from "../components/functionality";
import "../css/wrapper.css";
import { useTranslation } from "react-i18next";

const Wrapper = () => {
  const { t } = useTranslation();
  return (
    <div className="functionality-content" id="functionality">
      <h2>{t("Βασικές λειτουργίες του DotSpatial")}</h2>
      <Functionality />
    </div>
  );
};
export default Wrapper;
